export function openChatWithTerm(token: string, searchTerm: string) {
  const url = `https://ia.lex.com.br/auth/${token}?searchTerm=${encodeURIComponent(searchTerm)}`;
  window.open(url, "_blank");
}

export function openChat(token: string) {
  const url = `https://ia.lex.com.br/auth/${token}`;
  window.open(url, "_blank");
}
